import {
  history,
} from 'mutants-microfx';
import ViewController from './ViewController';

// 单据视图控制器
export default class VoucherViewController extends ViewController {

  create(){
    const {
      sysid,
      mid
    } = this.module;
    history.push(`/${sysid}/${mid}`);
  }

  openDraft(){
    const {
      sysid,
      mid
    } = this.module;
    history.push(`/${sysid}/${mid}?pid=draft`);
  }

  // 打开单据查询方案
  openSearch() {

  }

  // 打开单据列表
  openList() {
    const {
      sysid,
      mid
    } = this.module;
    history.push(`/${sysid}/${mid}?pid=list`);
  }

}
